<div class="center-section" *ngIf="this.actRoute.snapshot.paramMap.get('id')">

    <tabset #staticTabs3 [class.nav-hiddennnn]="id" type="fill innertabs d-flex nav-justified mb-2">
        <tab *ngFor="let mn of menuItems; let i=index;trackBy:trackByIndex;" (selectTab)="selectMenuItemTab(i, mn)">
            <ng-template tabHeading >
                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/{{mn.id == 'in_play' ? 'all' : mn.id}}.png">
                <span>{{mn.id == 'in_play' ? 'All' : mn.name}}</span>
            </ng-template>

            <!-- casino section -->
            <div class="custom-thumb-section" *ngIf="!casinoId">
              <div class="cts-img" href="javascript:void(0)" (click)="confirmLogin2(99995, 883)">
                  <img class="img-fluid" src="https://tezcdn.io/casino/casino-highlight/aviator.webp">
              </div>
              <div class="cts-img" (click)="redirectCasino('99995:smartsoft')">
                  <img class="img-fluid" src="https://tezcdn.io/casino/casino-highlight/smartsoft-500*299.webp">
              </div>
              <div class="cts-img" (click)="confirmLogin2(99995, 885)">
                  <img class="img-fluid" src="https://tezcdn.io/casino/casino-highlight/mines.webp">
              </div>
              <div class="cts-img" (click)="confirmLogin2(99995, 5318)">
                  <img class="img-fluid" src="https://tezcdn.io/casino/casino-live/teenpatti.webp">
              </div>
              <div class="cts-img" (click)="confirmLogin2(99999, 67600)">
                  <img class="img-fluid" src="https://tezcdn.io/casino/casino-live/muflis-teenpatti.webp">
              </div>
              <div class="cts-img" (click)="confirmLogin2(99995, 5323)">
                  <img class="img-fluid" src="https://tezcdn.io/casino/casino-live/3card-judgement.webp">
              </div>
              <div class="cts-img" (click)="confirmLogin2(99999, 67660)">
                  <img class="img-fluid" src="https://tezcdn.io/casino/casino-live/2card-teenpatti.webp">
              </div>
              <div class="cts-img" (click)="confirmLogin2(99999, 98794)">
                  <img class="img-fluid" src="https://tezcdn.io/casino/casino-live/dragon-tiger.webp">
              </div>
              <div class="cts-img" (click)="confirmLogin2(99999, 98791)">
                  <img class="img-fluid" src="https://tezcdn.io/casino/casino-live/amar-akbar-anthony.webp">
              </div>
              <div class="cts-img" (click)="confirmLogin2(99999, 67581)">
                  <img class="img-fluid" src="https://tezcdn.io/casino/casino-live/casino-war.webp">
              </div>
              <div class="cts-img" (click)="confirmLogin2(99999, 67564)">
                  <img class="img-fluid" src="https://tezcdn.io/casino/casino-live/poker.webp">
              </div>
              <div class="cts-img" (click)="confirmLogin2(99999, 92039)">
                  <img class="img-fluid" src="https://tezcdn.io/casino/casino-live/baccarat.webp">
              </div>
              <div class="cts-img" (click)="confirmLogin2(99999, 98789)">
                  <img class="img-fluid" src="https://tezcdn.io/casino/casino-live/7up-down.webp">
              </div>
              <div class="cts-img" (click)="confirmLogin2(99999, 98792)">
                  <img class="img-fluid" src="https://tezcdn.io/casino/casino-live/roulette.webp">
              </div>
              <div class="cts-img" (click)="confirmLogin2(99999, 67680)">
                  <img class="img-fluid" src="https://tezcdn.io/casino/casino-live/the-trap.webp">
              </div>
              <div class="cts-img" (click)="confirmLogin2(99999,67611)">
                  <img class="img-fluid" src="https://tezcdn.io/casino/casino-live/trio.webp">
              </div>
            </div>
            <!-- casino section -->
            
            <h2 class="inner-title" *ngIf="!casinoId">
                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/99995.png">
                I Casino
            </h2>
        </tab>
    </tabset>
</div>

<!-- casino1 -->
<div class="lvc-thumb" *ngIf="events.casino1.includes(id)">
    <div class="row">
        <div class="col-md-2 col-4" (click)="confirmLogin(item)" *ngFor="let item of data?.event_types;trackBy:trackByIndex;">
            <!-- <img class="img-fluid" src="assets/images/casino1/{{item?.id}}.png" alt="{{item?.name}}" title="{{item?.name}}"> -->
            <img class="img-fluid" [lazyLoad]="getImagePath(item)" alt="{{item.name}}" title="{{item?.name}}">
            <!-- <span>({{item?.id}} - {{item?.name}})</span> -->
        </div>
    </div>
    <app-loader class="no-overlay" *ngIf="isLoad"></app-loader>
</div>

<!-- i-casino -->
<div class="int-casino-content position-relative" *ngIf="events.iCasino.includes(id)">
    <div class="tab-container">
        <div class="market_section tabcasino">
            <div class="fancyTabs" *ngIf="data">
                <!-- <div *ngFor="let tabDt of data.tables;trackBy:trackByIndex;"> -->
                    <!-- old icasino code -->
                <!-- <tabset #parentTabs type="fill innertabs d-none" class="casino_tabs_ul" id="myInnerTab">
                    <tab id="goto-casino-{{i}}-link" [heading]="'1 To ' + tabDt.name" *ngFor="let tabDt of data.tables;let i=index;trackBy:trackByIndex;" (selectTab)="onSelectParent(i)">
                        <div class="icasino_ul_tabs">
                            <tabset #childTabs type="fill innertabs d-block">
                                <tab id="goto-casino-{{i}}{{j}}-link" *ngFor="let innerTabDt of tabDt.data;let j=index;trackBy:trackByIndex;" (selectTab)="onSelect(j)">
                                    <ng-template tabHeading>
                                        {{innerTabDt.name}}
                                    </ng-template>
                                    <div class="intcasino-sub-tab">
                                        <div class="row py-2 mx-0" *ngIf="tabId == j">
                                            <div class="col-md-2 col-4" (click)="confirmBox(item, tabDt.name)" *ngFor="let item of innerTabDt.data;trackBy:trackByIndex;">
                                                <div class="casino-images-box position-relative">
                                                    <img class="img-fluid" [src]="item.url_thumb ? item.url_thumb : item.image_path" alt="{{item.name}}">
                                                    <a href="javascript:void(0)" class="btn casino-btn">Play Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </tab>
                            </tabset>        
                        </div>
                    </tab>
                </tabset> -->
                <!-- </div> -->

                <!-- new icasino -->
                <tabset #parentTabs class="casino_tabs_ul">
                    <tab *ngFor="let tabDt of data;let i=index;trackBy:trackByIndex;" (selectTab)="onSelectParent(i)">
                        <ng-template tabHeading>
                            <span id="goto-casino-{{i}}-link">
                              <!-- {{tabDt?.name | uppercase}} -->
                            {{tabDt?.name.charAt(0).toUpperCase() + tabDt?.name.slice(1)}}
                            <!-- <img class="img-fluid" src="assets/img/icon/{{tabDt?.slug}}.png"> -->
                            </span>
                        </ng-template>
                        <div class="icasino_ul_tabs">
                            <tabset #childTabs>
                                <tab id="tab1" *ngFor="let innerTabDt of tabDt.data;let j=index;trackBy:trackByIndex;" (selectTab)="onSelect(j)">
                                    <ng-template tabHeading>
                                        <img class="img-fluid tab-image" src="https://speedcdn.io/assets/int_tab_icons/{{innerTabDt?.slug}}.png">
                                        <!-- {{innerTabDt?.name | uppercase}} -->
                                        {{innerTabDt?.name.charAt(0).toUpperCase() + innerTabDt?.name.slice(1)}}
                                    </ng-template>
                                    <div class="intcasino-sub-tab">
                                        <div class="row py-2 mx-0" *ngIf="tabId == j">
                                            <div class="col-md-2 col-4" (click)="confirmBox(item, tabDt.name)" *ngFor="let item of innerTabDt.data;trackBy:trackByIndex;">
                                                <div class="casino-images-box position-relative">
                                                    <img class="img-fluid" [lazyLoad]="item.url_thumb ? item.url_thumb : item.image_path" alt="{{item.name}}">
                                                    <a href="javascript:void(0)" class="btn casino-btn">Play Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </tab>
                            </tabset>
                        </div>
                    </tab>
                </tabset>
            </div>
        </div>
    </div>
    <app-loader class="no-overlay" *ngIf="isLoad"></app-loader>
</div>


<!-- Int Casino -->
<div class="int-casino-content position-relative" *ngIf="events.intCasino.includes(id)">
    <div class="tab-container">
        <div class="market_section tabcasino">
            <div class="fancyTabs">
                <tabset #parentTabs class="casino_tabs_ul">
                    <tab *ngFor="let tabDt of data;let i=index;trackBy:trackByIndex;" (selectTab)="onSelectParent(i)">
                        <ng-template tabHeading>
                            {{tabDt?.name}}
                            <!-- <img class="img-fluid" src="assets/img/icon/{{tabDt?.slug}}.png"> -->
                        </ng-template>
                        <div class="icasino_ul_tabs">
                            <tabset>
                                <tab id="tab1" *ngFor="let innerTabDt of tabDt.data;let j=index;trackBy:trackByIndex;" (selectTab)="onSelect(j)">
                                    <ng-template tabHeading>
                                        <img class="img-fluid" src="https://speedcdn.io/assets/int_tabs_icons/{{innerTabDt?.slug}}.png">
                                        {{innerTabDt.name}}
                                    </ng-template>
                                    <div class="intcasino-sub-tab">
                                        <div class="row py-2 mx-0" *ngIf="tabId == j">
                                            <div class="col-md-2 col-4" (click)="confirmBox(item, tabDt.name)" *ngFor="let item of innerTabDt.data;trackBy:trackByIndex;">
                                                <div class="casino-images-box position-relative">
                                                    <img class="img-fluid" [src]="item.url_thumb ? item.url_thumb : item.image_path" alt="{{item.name}}">
                                                    <a href="javascript:void(0)" class="btn casino-btn">Play Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </tab>
                            </tabset>
                        </div>
                    </tab>
                </tabset>
            </div>
        </div>
    </div>
    <app-loader class="no-overlay" *ngIf="isLoad"></app-loader>
</div>
<!--/ Int Casino End -->